import { AuthErrorCodes } from "./constants";
import { AuthError, TokenResponse } from "./type";

export const getToken = (username: string, callback: (error?: AuthError, result?: TokenResponse) => void) => {
    return new Promise((resolve, _) => {
        if (!(window as any).geotabModules?.auth["getToken"]) {
            resolve(undefined);
        }

        (window as any).geotabModules.auth["getToken"]({ username }, callback);
    });
};

export const getTokenFromSecureStorage = async (username: string): Promise<string | null | undefined> => {
    return new Promise((resolve, _) => {
        if (!(window as any).geotabModules?.auth["getToken"]) {
            resolve(undefined);
        }

        (window as any).geotabModules.auth["getToken"]({ username }, (error?: AuthError, result?: TokenResponse) => {
            if (result && result.accessToken) {
                resolve(result.accessToken);
                return;
            }

            // return undefined if no access token found or reauthentication is required 
            // native side already attempt to reauthenticate in these cases
            if (error?.code === AuthErrorCodes.NO_ACCESS_TOKEN_FOUND || error?.code === AuthErrorCodes.PARSE_FAILED_FOR_AUTH_STATE || error?.requiresReauthentication) {
                resolve(undefined);
                return;
            }

            // if error is recoverable, try to get token again
            if (error?.recoverable) {
                (window as any).geotabModules?.auth["getToken"]({ username }, (_, retriedResult?: { accessToken: string }) => {
                    if (retriedResult && retriedResult.accessToken) {
                        resolve(retriedResult.accessToken);
                        return;
                    }

                    resolve(undefined);
                });
                return;
            }

            resolve(undefined);
        });
    });
};